module.exports = __webpack_public_path__ + "static/media/visa-icon.414993e7.png";